import { render, staticRenderFns } from "./ApplicationEditWorkplaceModal.vue?vue&type=template&id=38bbc8ee&"
import script from "./ApplicationEditWorkplaceModal.vue?vue&type=script&lang=ts&"
export * from "./ApplicationEditWorkplaceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports